export type DashboardRouteIntent =
	| { kind: "latest" }
	| { kind: "message"; mid: number };

export const getDashboardRouteIntent = (routeUrl: string) => {
	const url = new URL(routeUrl, "https://dashboard.intent.invalid");
	const midRaw = url.searchParams.get("m_open_mid");
	const latest = url.searchParams.get("m_open_latest") === "1";
	const consumed = midRaw !== null || url.searchParams.has("m_open_latest");
	let intent: DashboardRouteIntent | undefined;

	if (latest) {
		intent = { kind: "latest" };
	} else if (midRaw !== null) {
		const mid = Number.parseInt(midRaw, 10);
		if (Number.isFinite(mid)) {
			intent = { kind: "message", mid };
		}
	}

	url.searchParams.delete("m_open_mid");
	url.searchParams.delete("m_open_latest");

	return {
		cleanUrl: `${url.pathname}${url.search}${url.hash}`,
		consumed,
		intent,
	};
};
